// components
import HeadText from "../components/HeadText";
import Header from "../components/Header";
import Footer from "../components/Footer";
import {
  MembershipSub,
  WhatItIs,
  PartnerContent,
  Utility,
  FlowText,
  MembersMobileContent,
} from "../components/membership";
// import ChildTitle from "../components/ChildTitle";
import PartnerHead from "../components/membership/PartnerHead";
import { Typography, useMediaQuery, Link, Stack, Button } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function MembershipPage({
  address,
  userSigner,
  localProvider,
  mainnetProvider,
  price,
  web3Modal,
  loadWeb3Modal,
  logoutOfWeb3Modal,
  blockExplorer,
  contract,
  remainTokenCount,
  remainMintCount,
  saleStatus,
}) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <>
      {isDesktop && (
        <>
          <Header
            web3Modal={web3Modal}
            loadWeb3Modal={loadWeb3Modal}
            logoutOfWeb3Modal={logoutOfWeb3Modal}
            text={"MEMBERS"}
          />
          <div className="page">
            <HeadText title={"MEMBERS"} />
            <MembershipSub />
            <WhatItIs />
            <Utility />
            <FlowText />
            <PartnerHead title={"PARTNERS"} />
            <PartnerContent />
          </div>

          <Footer />
        </>
      )}

      {!isDesktop && (
        <>
          <Header
            web3Modal={web3Modal}
            loadWeb3Modal={loadWeb3Modal}
            logoutOfWeb3Modal={logoutOfWeb3Modal}
            text={"MEMBERS"}
          />
          <MembersMobileContent
            address={address}
            localProvider={localProvider}
            userSigner={userSigner}
            mainnetProvider={mainnetProvider}
            price={price}
            web3Modal={web3Modal}
            loadWeb3Modal={loadWeb3Modal}
            logoutOfWeb3Modal={logoutOfWeb3Modal}
            blockExplorer={blockExplorer}
            contract={contract}
            remainTokenCount={remainTokenCount}
            remainMintCount={remainMintCount}
            saleStatus={saleStatus}
          />
        </>
      )}
    </>
  );
}
